import { GENERAL_ERROR_ADD, GENERAL_ERROR_REMOVE } from "../constants";

export const catchError = (ex, onError) => (dispatch) => {
    if (ex.response) {
        ex.response.json().then((error) => dispatch(onError(error)));
    } else {
        dispatch(onError(ex));
    }
};

export const catchErrorNoDispatch = (ex, onError) => {
    if (ex.response) {
        ex.response.json().then((error) => onError(error));
    } else {
        onError(ex);
    }
}

export const generalErrorAdd = (error) => ({
    type: GENERAL_ERROR_ADD,
    payload: error,
});

export const generalErrorRemove = (messageId) => ({
    type: GENERAL_ERROR_REMOVE,
    payload: messageId
})